import toast from 'react-hot-toast';

import { IconClose } from '../../../common/icons';
import { useModalDialog } from '../../../common/hooks/use-modal-dialog';
import { fmtMoney } from '../../../common/utils/money';
import { useReverseBatch } from '../contexts/liquidations';

import '../styles/billing.css';

// Confirmación de reversa de un período CONTABILIZADO (batch `posted`). La reversa es
// append-only (admin-billing-payments.md): emite una nota-crédito + su asiento inverso por
// cada asiento del batch, deja el período en `reversed` y NO borra liquidaciones/reparto.
// Tras reversar, el período puede regenerarse. Acción sensible → doble confirmación.
const MONTHS = ['Enero', 'Febrero', 'Marzo', 'Abril', 'Mayo', 'Junio', 'Julio', 'Agosto', 'Septiembre', 'Octubre', 'Noviembre', 'Diciembre'];

export default function ReverseBatchModal({ batch, onClose, onReversed }) {
    const { mutateAsync: reverse, isPending: busy } = useReverseBatch();
    const cardRef = useModalDialog(onClose);
    const period = `${MONTHS[(batch.period_month || 1) - 1]} ${batch.period_year}`;

    const submit = async () => {
        try {
            await reverse(batch.id);
            toast.success(`Liquidación de ${period} reversada`);
            onReversed?.();
        } catch (er) {
            if (er?.status === 409) toast.error('El período no está contabilizado o ya fue reversado');
            else if (er?.status === 404) toast.error('No se encontró el período');
            else if (er?.status !== 403) toast.error(er?.message || 'No se pudo reversar el período');
        }
    };

    return (
        <div className="billing-modal" role="dialog" aria-modal="true" aria-label={`Revertir liquidación de ${period}`}>
            <div className="billing-modal__overlay" onClick={busy ? undefined : onClose} aria-hidden="true" />
            <div className="billing-modal__card" ref={cardRef}>
                <header className="billing-modal__head">
                    <div>
                        <h2 className="billing-modal__title">Revertir período contabilizado</h2>
                        <span className="billing-modal__sub">{period}</span>
                    </div>
                    <button type="button" className="billing-modal__close" onClick={onClose} disabled={busy} aria-label="Cerrar"><IconClose /></button>
                </header>

                <div className="billing-confirm">
                    <p className="billing-confirm__text">
                        Vas a revertir la liquidación <strong>ya contabilizada</strong> de <strong>{period}</strong>.
                    </p>
                    <ul className="billing-confirm__facts">
                        <li><span>Vacas</span><strong>{batch.animal_count ?? '—'}</strong></li>
                        <li><span>Líneas</span><strong>{batch.liquidation_count ?? '—'}</strong></li>
                        <li><span>Total pensión</span><strong>{fmtMoney(batch.totals?.pension_total)}</strong></li>
                    </ul>
                    <p className="billing-confirm__warn">
                        Se emite una nota-crédito por cada asiento (contabilidad de doble partida): <strong>nada se
                        borra</strong>, el período queda como <strong>Reversada</strong> y podés volver a generarlo.
                    </p>
                </div>

                <footer className="billing-modal__foot">
                    <button type="button" className="billing-btn billing-btn--ghost" onClick={onClose} disabled={busy}>Cancelar</button>
                    <button type="button" className="billing-btn billing-btn--danger" onClick={submit} disabled={busy}>{busy ? 'Revirtiendo…' : 'Revertir período'}</button>
                </footer>
            </div>
        </div>
    );
}
